import EmploymentRecord from './EmploymentRecord';
import { computed, observable, makeObservable } from 'mobx';
import {types} from 'main/tools';
import {LeaveType} from 'main/stores/leave_types';
import {calendarDate} from 'shared/tools';

class OnLeaveRecord extends EmploymentRecord {
  leaveType;
  expectedReturnDate;
  lastDayOfWorkBeforeLeave;
  skipAccruals;

  _relations = {
    ...this._relations,
    leaveType: LeaveType,
    _dates: [...this._relations._dates, 'expectedReturnDate', 'lastDayOfWorkBeforeLeave']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      leaveType: observable,
      expectedReturnDate: observable,
      lastDayOfWorkBeforeLeave: observable,
      skipAccruals: observable,
      expectedReturnDateView: computed
    });

    this.merge(other);
  }

  _afterMerge() {
    this._type = types.ON_LEAVE_RECORD;
  }

  get expectedReturnDateView() {
    return calendarDate(this.expectedReturnDate);
  }
}

export default OnLeaveRecord;
